import { Box } from '@mui/material';
import { studioFooterStyles } from './StudioFooter.styles';
import { StudioFooterBackendVersion } from './StudioFooterBackendVersion';
import { StudioFooterStudioVersion } from './StudioFooterStudioVersion';

export const StudioFooter = () => {
  return (
    <Box component="footer" sx={studioFooterStyles.footer}>
      <StudioFooterStudioVersion />
      <StudioFooterBackendVersion />
    </Box>
  );
};
